<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue, HTMLAttributes, HTMLInputAttributes, HTMLLabelAttributes } from "svelte/elements";

	const {
		horizontal,
		label,
		required,
		content,
		wrapperClass,
		...rest
	}: HTMLAttributes<HTMLDivElement> & {
		wrapperClass?: ClassValue;
		required?: HTMLInputAttributes["required"];
		horizontal?: boolean;
		label?: HTMLLabelAttributes;
		content: Snippet;
	} = $props();
</script>

<div class={["flex text-left gap-1 leading-normal", horizontal ? "flex-row items-center" : "flex-col", wrapperClass]}>
	{#if horizontal}
		{@render content()}
	{/if}
	<label {...label} class={["px-4 pb-1 text-sm", label?.class]}>
		{@render rest.children?.()}
		{#if required}
			<span>*</span>
		{/if}
	</label>
	{#if !horizontal}
		{@render content()}
	{/if}
</div>
